/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit na mapě`
};

const da_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Vis på kort`
};

const de_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Auf der Karte anzeigen`
};

const en_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Show on map`
};

const es_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Ver en el mapa`
};

const fr_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Voir sur la carte`
};

const hu_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Megtekintés a térképen`
};

const it_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi sulla mappa`
};

const nl_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Toon op kaart`
};

const pl_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Pokaż na mapie`
};

const pt_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Ver no mapa`
};

const sv_show_map = /** @type {(inputs: {}) => string} */ () => {
	return `Visa på karta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show_map = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show_map(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show_map", locale)
	if (locale === "cs") return cs_show_map(inputs)
	if (locale === "da") return da_show_map(inputs)
	if (locale === "de") return de_show_map(inputs)
	if (locale === "en") return en_show_map(inputs)
	if (locale === "es") return es_show_map(inputs)
	if (locale === "fr") return fr_show_map(inputs)
	if (locale === "hu") return hu_show_map(inputs)
	if (locale === "it") return it_show_map(inputs)
	if (locale === "nl") return nl_show_map(inputs)
	if (locale === "pl") return pl_show_map(inputs)
	if (locale === "pt") return pt_show_map(inputs)
	return sv_show_map(inputs)
};